import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/SplitPageLayout/SplitPageLayout.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/split-page-layout/react/latest'} mdxType="DeprecationBanner" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {SplitPageLayout} from '@primer/react'
`}</code></pre>
    <Note mdxType="Note">
      <p>{`If you need a more flexible layout component, consider using the `}<a parentName="p" {...{
          "href": "/PageLayout"
        }}>{`PageLayout`}</a>{` component.`}</p>
    </Note>
    <h2>{`Examples`}</h2>
    <h3>{`Minimal`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With overflowing pane content`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane>
      <Box sx={{display: 'grid', gap: 3}}>
        {Array.from({length: 5}).map((_, i) => (
          <Box key={i} as="p" sx={{margin: 0}}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam at enim id lorem tempus egestas a non ipsum.
            Maecenas imperdiet ante quam, at varius lorem molestie vel. Sed at eros consequat, varius tellus et, auctor
            felis. Donec pulvinar lacinia urna nec commodo. Phasellus at imperdiet risus. Donec sit amet massa purus.
          </Box>
        ))}
      </Box>
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With pane hidden on narrow viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane hidden={{narrow: true}}>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With content hidden on narrow viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane divider={{regular: 'line', narrow: 'none'}}>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content hidden={{narrow: true}}>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With resizable pane`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane resizable>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`Without dividers`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header divider="none">
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane divider="none">
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer divider="none">
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With pane on right`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Pane position="end">
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With condensed padding`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header padding="condensed">
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane padding="condensed">
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content padding="condensed">
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer padding="condensed">
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`Without padding`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header padding="none">
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane padding="none">
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content padding="none">
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer padding="none">
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`Without header or footer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Pane>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={480} />
    </SplitPageLayout.Content>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With heading`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Pane>
      <Heading as="h2">Pane Heading</Heading>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={480} />
    </SplitPageLayout.Content>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With non-sticky pane`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <SplitPageLayout>
    <SplitPageLayout.Header>
      <Placeholder label="Header" height={64} />
    </SplitPageLayout.Header>
    <SplitPageLayout.Pane sticky={false}>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h3>{`With a custom sticky header`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<Box sx={{height: 320, overflowY: 'auto', border: '1px solid', borderColor: 'border.default'}}>
  <Box
    sx={{
      position: 'sticky',
      top: 0,
      height: 64,
      display: 'grid',
      placeItems: 'center',
      backgroundColor: 'canvas.subtle',
      borderBottom: '1px solid',
      borderColor: 'border.default',
      zIndex: 1,
    }}
  >
    Custom sticky header
  </Box>
  <SplitPageLayout>
    <SplitPageLayout.Content>
      <Placeholder label="Content" height={420} />
    </SplitPageLayout.Content>
    <SplitPageLayout.Pane sticky offsetHeader={64}>
      <Placeholder label="Pane" height={120} />
    </SplitPageLayout.Pane>
    <SplitPageLayout.Footer>
      <Placeholder label="Footer" height={64} />
    </SplitPageLayout.Footer>
  </SplitPageLayout>
</Box>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      